import { render } from "./GridSkeletonLoader.vue?vue&type=template&id=278a07c4"
import script from "./GridSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./GridSkeletonLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__